import * as React from 'react'
import { useIntl } from 'react-intl'
import MessagingLabel from 'LuxKit/Label/MessagingLabel'

const ALMOST_GONE_TAG = 'almost_gone'
const SELLING_FAST_TAG = 'selling_fast'
const TRENDING_TAG = 'trending'

interface Props {
  urgencyTags?: Array<string>;
}

function ExperienceUrgencyTag({ urgencyTags }: Props) {
  const intl = useIntl()

  if (!urgencyTags?.length) return null

  if (urgencyTags.includes(ALMOST_GONE_TAG)) {
    return (
      <MessagingLabel variant="urgencyNormal">
        {intl.formatMessage({
          id: 'mr1jMv_mUehO3c3Ua-oa',
          defaultMessage: 'Almost gone',
          description: 'Urgency badge shown on experience offer tiles when availability is critically low',
        })}
      </MessagingLabel>
    )
  }

  if (urgencyTags.includes(SELLING_FAST_TAG)) {
    return (
      <MessagingLabel variant="successLight">
        {intl.formatMessage({
          id: '8zaSoYdyvcmL8GK9J2D_',
          defaultMessage: 'Selling fast',
          description: 'Urgency badge shown on experience offer tiles that are selling fast',
        })}
      </MessagingLabel>
    )
  }

  if (urgencyTags.includes(TRENDING_TAG)) {
    return (
      <MessagingLabel variant="successLight">
        {intl.formatMessage({
          id: 'G1j_QCxN3yznUN72mDQg',
          defaultMessage: 'Trending',
          description: 'Urgency badge shown on experience offer tiles that are trending',
        })}
      </MessagingLabel>
    )
  }

  return null
}

export default React.memo(ExperienceUrgencyTag)
